var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrunchbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_2._crunchbase",
    "data-name": "2. crunchbase",
    d: "M5,56.5A51.5,51.5,0,1,1,56.5,108,51.5,51.5,0,0,1,5,56.5ZM35.193,41.817a17.374,17.374,0,1,0,18.953,21.37H46.33a9.935,9.935,0,1,1,0-8.24h7.816a17.361,17.361,0,0,0-18.953-13.13ZM81.6,75.051a16.708,16.708,0,0,0,4.991-2.966A17.279,17.279,0,0,0,75.334,41.669H74.063a17.6,17.6,0,0,0-8.475,2.966V25.284H58.525V75.051h7.109V73.262A17.327,17.327,0,0,0,81.6,75.051ZM65.726,59.062a9.906,9.906,0,1,1,19.812,0h0a9.905,9.905,0,1,1-19.811,0Zm19.812,0Z",
    transform: "translate(-5 -5)",
    fill: "#3b86cc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrunchbase);
export default __webpack_public_path__ + "static/media/crunchbase.746616aa9ce22606d3978bc5cf82760d.svg";
export { ForwardRef as ReactComponent };